import { NavigateOptions } from 'react-router-dom';

/**
 * Creates a navigation function that preserves the current URL state for back navigation
 * @param navigate - React Router's navigate function
 * @param route - The base route to navigate to (e.g., routes.block, routes.extrinsic)
 * @returns A function that accepts an ID and navigates to the detail page with state
 */
export const createDetailNavigation = (
  navigate: (to: string, options?: NavigateOptions) => void,
  route: string
) => {
  return (id: string) => {
    // Handle IDs that might need preprocessing (like removing # symbol)
    const processedId = typeof id === 'string' && id.replace ? id.replace('#', '') : id;

    // Navigate to the detail page with current hash for back navigation
    navigate(`${route}/${processedId}`, {
      state: {
        from: {
          hash: window.location.hash,
        },
        navigatedTo: true,
      },
    });
  };
};
